import React, { useState } from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import ShareCourseContentLink from "./components/shareCourseContentLink";
import DialogCloseButton from "Components/Fragment/DialogCloseButton";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../themes/theme";
import { IconButton } from "Components/Base/Inputs/IconButton";
import { ShareIcon } from "Components/Icons";

const Share = ({ languageContext, subject }) => {
  const [active, setActive] = useState(false);

  const closeForm = () => {
    setActive(false);
  };

  const openForm = () => {
    setActive(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <IconButton
          onClick={openForm}
          title={languageContext("share")}
          icon={<ShareIcon />}
          size="small"
        />
        <DialogCloseButton
          fullWidth
          maxWidth="sm"
          open={active}
          handleClose={closeForm}
          title={languageContext("share")}
          closeText={languageContext("close")}
          scrollable
          text={
            <ShareCourseContentLink
              languageContext={languageContext}
              subject={subject}
            />
          }
        />
      </div>
    </ThemeProvider>
  );
};

export default withLanguageContext(Share, "Rating");
